export const RECEIVED_ATTACHMENT_TREE = "RECEIVED_ATTACHMENT_TREE";
export const REQUEST_ATTACHMENT_TREE = "REQUEST_ATTACHMENT_TREE";
export const REQUESTED_ATTACHMENT_TREE = "REQUESTED_ATTACHMENT_TREE";
